const MONTHS_IN_QUARTER = {
    'Q1': ['January','February','March'],
    'Q2': ['April','May','June'],
    'Q3': ['July','August','September'],
    'Q4': ['October','November','December'],
}

export const getQuarterReportColumns = (quarter) => {
    let baseColumns = [
        {
            title: 'Category',
            dataIndex: 'category',
        },
        {
            title: 'Weightage',
            dataIndex: 'weightage',
            align: "center",
            key: 'weightage',
            width: 200,
        },
    ]
    if(quarter){
        MONTHS_IN_QUARTER[quarter.split('-')[1]].forEach(item=>{
            baseColumns.push({
                title: item,
                dataIndex: item + ' - ' + quarter.split('-')[0],
                align: "center",
                key: 'score',
                width: 200,
            })
        })
    }
    baseColumns.push(
        {
            title: 'Average Score',
            dataIndex: 'score',
            align: "center",
            key: 'score',
            width: 200,
        },
        {
            title: 'Weighted Score',
            dataIndex: 'weighted_score',
            align: "center",
            key: 'weighted_score',
            width: 200,
        }
    )

    return baseColumns

}